export enum PERFORMANCE_CHART_TYPE {
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_7_DAYS = 'LAST_7_DAYS'
}

export enum INCENTIVE_BUCKET_GROUP {
  TOTAL = 'Total',
  DPD_1_TO_30 = '1-30',
  DPD_30_PLUS = '30+'
}
